import AbandonedCartHandler from './abandoned-cart-handler'

const requires = {
  AbandonedCartHandler,
}

Object.values(requires).forEach(component => {
  Vue.component(component.name, component)
})

export default requires
